import type { CustomFlowbiteTheme } from 'flowbite-react';

export const clipboardTheme: CustomFlowbiteTheme['clipboard'] = {
  button: {
    base: 'inline-flex w-full items-center justify-center rounded-lg bg-titan-folly-700 px-5 py-3 hover:bg-titan-folly-800 focus:outline-none focus:ring-4 focus:ring-titan-folly-300',
    label: 'text-center text-sm font-medium text-white sm:w-auto',
  },
  withIcon: {
    base: 'absolute end-2 top-1/2 inline-flex -translate-y-1/2 items-center justify-center rounded-lg p-2 text-titan-night-500 hover:bg-titan-night-100',
    icon: {
      defaultIcon: 'h-4 w-4',
      successIcon: 'h-4 w-4 text-titan-folly-700',
    },
  },
  withIconText: {
    base: 'absolute end-2.5 top-1/2 inline-flex -translate-y-1/2 items-center justify-center rounded-lg border border-titan-night-200 bg-white px-2.5 py-2 text-titan-night-900 hover:bg-titan-night-100',
    icon: {
      defaultIcon: 'me-1.5 h-3 w-3',
      successIcon: 'me-1.5 h-3 w-3 text-titan-folly-700',
    },
    label: {
      base: 'inline-flex items-center',
      defaultText: 'text-xs font-semibold',
      successText: 'text-xs font-semibold text-titan-folly-700',
    },
  },
};
